import {COMMON_ROUTES} from 'routes/common';

export const ROUTES = {
  ...COMMON_ROUTES,
  COMING_SOON: '/comingsoon',
  SUPPLIERS: '/suppliers',
  SUPPLIER: '/supplier/:sId',
  USER: '/supplier-user/:sId',
  LOTS: '/lots',
  LOT: '/lot/:sId',
  LOT_CREATE: '/lot/create',
  PRODUCTS: '/products',
  SUPPLIER_USER: '/supplier/user/:sId',
  PROJECTS: '/projects',
  PROJECT_CREATE: '/projects/create',
  PROJECT: '/projects/:pId',
  ERROR: '/error',
  OFFER: '/projects/:pId?modal-offer=:offerId',
  DEMANDS: '/demands',
  DEMAND: '/demands/:dId',
};
